<template>
	<div>
		<div class="row">
			<div class="col-lg-12">
				<h1 class="page-header">Kunden</h1>
			</div>
		</div>

		<graveyard-select></graveyard-select>

		<custom-table edit="/customers/{:id}" add="/customers/new" :src-model="$store.getters.models('customers')" search :cols="cols" :default-sort="defSort"></custom-table>
	</div>
</template>

<script>
import CustomTable from './../components/custom-table.vue'
import GraveyardSelect from 'components/graveyard-select.vue'

import store from 'root/store.js'
import { authCheck } from 'functions/auth_check.js'

export default {
	beforeRouteEnter (to, from, next) {
		const route = authCheck('customers')
		if (route === null) {
			next()
		} else {
			next(route)
		}
	},

	data () {
		return {
			cols: [
				{ 'name': 'Kdr-Nummer', 'json': 'id', 'type': 'int' },
				{ 'name': 'Vorname', 'json': 'firstname', 'type': 'text' },
				{ 'name': 'Nachname', 'json': 'lastname', 'type': 'text' },
				{ 'name': 'Gräber', 'json': 'grave_count', 'type': 'int' }
			],
			defSort: { col: 'id', order: 'asc' }
		}
	},

	components: {
		'graveyard-select': GraveyardSelect,
		'custom-table': CustomTable
	},

	activated () {
		this.$store.dispatch('loadModel', 'customers')
		.then(response => {
			//
		})
		.catch(err => {
			//
		})
	}
}
</script>

<style>
#app {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
}
</style>



// WEBPACK FOOTER //
// CustomerOverview.vue?4ed52d69